"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LogoRenderer = void 0;

var jsx_runtime_1 = require("@emotion/react/jsx-runtime");

var frontend_assets_1 = require("@ryerson/frontend.assets");

var StyledComponents_1 = require("./StyledComponents");

var gatsby_1 = require("gatsby");

var util_1 = require("../common/util");

var __1 = require("..");

var frontend_layout_1 = require("@ryerson/frontend.layout");

var LogoRenderer = function LogoRenderer(_ref) {
  var companyName = _ref.companyName,
      _ref$isSticky = _ref.isSticky,
      isSticky = _ref$isSticky === void 0 ? {
    current: false
  } : _ref$isSticky,
      mobileBreakPoint = _ref.mobileBreakPoint,
      _ref$isMobile = _ref.isMobile,
      isMobile = _ref$isMobile === void 0 ? false : _ref$isMobile;
  var sticky = isSticky === null || isSticky === void 0 ? void 0 : isSticky.current;

  switch (companyName) {
    case __1.companyNameData.ryerson:
      return (0, jsx_runtime_1.jsx)(frontend_assets_1.RyersonLogo, {
        onClick: function onClick() {
          return (0, gatsby_1.navigate)((0, util_1.getUrl)("/"));
        },
        width: isMobile ? "120px" : "237px",
        color: sticky ? "white" : "blue",
        css: !isMobile && mobileBreakPoint && isSticky ? (0, StyledComponents_1.logoStyle)(mobileBreakPoint, isSticky === null || isSticky === void 0 ? void 0 : isSticky.current) : undefined
      });

    case __1.companyNameData.southernToolSteel:
      {
        var height = (isSticky === null || isSticky === void 0 ? void 0 : isSticky.current) ? "85px" : isMobile ? "65px" : "160px";
        return (0, jsx_runtime_1.jsx)(frontend_layout_1.Flex, {
          alignItems: "center",
          children: (0, jsx_runtime_1.jsx)(frontend_assets_1.STSLogo, {
            onClick: function onClick() {
              return (0, gatsby_1.navigate)((0, util_1.getUrl)("/"));
            },
            height: height,
            color: (isSticky === null || isSticky === void 0 ? void 0 : isSticky.current) ? "white" : "black"
          })
        });
      }

    default:
      return null;
  }
};

exports.LogoRenderer = LogoRenderer;